export const environment = {
  production: false,
  showComingSoon: false,
  paymentCurrency: 'GBP',
  paymentCurrencySymbol: '£',
  url: 'https://api-beta-v2.etailsupport.com/api/',
  imagesPath: 'https://api-beta-v2.etailsupport.com/wwwroot/',
  videosPath: 'https://api-beta-v2.etailsupport.com/wwwroot/',
  googleClientId:
    '695995558176-bjanvgui72vv3jc1029s5it9np2m0ra5.apps.googleusercontent.com',
  googleClientSecret: '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',
  googleRedirectUri: 'https://beta.cleverdeals.net/home',
  facebookClientId: '3296811690460709',
  facebookRedirectUri: 'https://beta.cleverdeals.net/home',
  facebookVersion: 'v18.0',
  facebookScope: 'email,public_profile,Business Asset User Profile Access',
  facebookFields: 'id,name,email,picture',
  facebookApiUrl: '/me',
  facebookApiFields: 'id,name,email,picture',
  mollieProfileId: 'pfl_zbMQSow2nP',
  isTestMode: true,
};
